export default {
    // Temp fonts
    fonts: {
      title: "Space Grotesk, sans-serif",
      main: "Space Grotesk, sans-serif"
    },
    // Colors for layout
    colors: {
      primary1: "#FDB813",
      background1: "#0A1628",
      button: "#FDB813",
      background2: "#132337",
      text: "#F5F5F5",
      text1: "#FFFFFF",
      text2: "#B8C5D6",
      text3: "#60A5FA",
      footerBackground: "#050D1A"
    },
    // Breakpoints for responsive design
    breakpoints: {
      sm: 'screen and (max-width: 640px)',
      md: 'screen and (max-width: 768px)',
      lg: 'screen and (max-width: 1024px)',
      xl: 'screen and (max-width: 1280px)'
    },
  }